//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import styled from 'styled-components';

import PostableStatus from '@models/PostableStatus';

export const EditablePostStatuses = [
  PostableStatus.Scheduled,
  PostableStatus.Rescheduled,
  PostableStatus.Failed,
];

export const TOP_NAVIGATION_HEIGHT = 56;
export const SIDEBAR_WIDTH = 231;

export const CALENDAR_TIMELINE_WIDTH = 784;

export const CALENDAR_MONTH_VIEW_MEDIA_SIZE = 48;
export const CALENDAR_MONTH_VIEW_MEDIA_HEIGHT = 48;
export const CALENDAR_MONTH_VIEW_MEDIA_WIDTH = 40;
export const CALENDAR_MONTH_VIEW_BIG_MEDIA_SIZE = 84;
export const CALENDAR_MONTH_VIEW_POST_TYPE_SIZE = 17;
export const CALENDAR_MONTH_VIEW_STATUS_SIZE = 14;
export const CALENDAR_MONTH_VIEW_ICON_SIZE = 15;

export const CALENDAR_TIMELINE_VIEW_POST_TYPE_SIZE = 22;

export const CALENDAR_NO_SOCIALS_MODAL_ICON_SIZE = 36;

export const CALENDAR_POST_DETAILS_MODAL_ICON_SIZE = 23;

export const CALENDAR_TOOLTIP_POSTED_CONTENT = 'This post is published.';
export const CALENDAR_TOOLTIP_PROCESSING_CONTENT =
  'This post is being processed. Check back soon to view its updated status.';
export const CALENDAR_TOOLTIP_FAILED_CONTENT = 'Post failed.';
export const CALENDAR_TOOLTIP_MORE_INFO = 'Click to view more info.';
export const CALENDAR_TOOLTIP_MANUAL_PAST_DUE_INTRO =
  'This manual post is past due.';
export const CALENDAR_TOOLTIP_MANUAL_INTRO = 'This is a manual post.';
export const CALENDAR_TOOLTIP_DRAFT_CONTENT =
  'This is a draft post and is not visible on any social channels.';
export const CALENDAR_TOOLTIP_MANUAL_CONTENT =
  'Bazaarvoice will not publish this post automatically.';

export const PINTEREST_CAPTION_HEIGHT = '100px';
export const CAPTION_HEIGHT = '136px';
export const MODAL_WIDTH = '550px';
export const MEDIA_WIDTH = '180px';
export const ASPECT_RATIO = 5 / 4;
export const SINGLE_MEDIA_HEIGHT = `calc(${MEDIA_WIDTH} * ${ASPECT_RATIO})`;
export const MEDIA_CONTAINER_HEIGHT = '294px';

export enum PostDetailsValidationError {
  CaptionTooLong = 'CaptionTooLong',
  TitleTooLong = 'TitleTooLong',
  PostTimeInPast = 'PostTimeInPast',
}

export const POST_TIME_IN_PAST_ERROR_TEXT =
  'Please select a post time in the future.';

export const CHARACTERS_REMAINING_THRESHOLD = 10;

export const SOCIAL_USER_LABEL_HEIGHT = '19px';

export const VerticalSpacerLarge = styled.div(
  ({ theme }) => `
    height: ${theme.spacings[3]};
`,
);

export const VerticalSpacerMedium = styled.div(
  ({ theme }) => `
    height: ${theme.spacings[2]};
`,
);

export const VerticalSpacerSmall = styled.div(
  ({ theme }) => `
    height: ${theme.spacings[1]};
`,
);

export const ONE_HOUR_IN_MS = 3600000;
export const ONE_MINUTE_IN_MS = 60000;
export const CALENDAR_NAVIGATION_TIMEOUT_MS = 1000;

export const CALENDAR_WEEK_VIEW_MEDIA_SIZE = 600;

export const CALENDAR_WEEK_VIEW_ITEM_HEIGHT = 220;
export const CALENDAR_WEEK_VIEW_ITEM_HEIGHT_SMALL =
  CALENDAR_WEEK_VIEW_ITEM_HEIGHT / 2 - 2;

export const CALENDAR_WEEK_VIEW_STATUS_SIZE = 12;
export const CALENDAR_WEEK_VIEW_NETWORK_ICON_SIZE = 12;

export const CALENDAR_MIN_WIDTH = 1194;
export const CALENDAR_MAX_WIDTH = 2144;
export const CALENDAR_WIDTH_BREAKPOINT = CALENDAR_MIN_WIDTH + 268 + 231;

export const DRAFT_WIDTH_BREAKPOINT = 840;
export const DRAFT_MIN_WIDTH = 600;

export const CALENDAR_MONTH_VIEW_LARGE_POST_STATUS_ICON_MIN_WIDTH = 2090;
